import { render, staticRenderFns } from "./ExpensesTable.vue?vue&type=template&id=a6bda52c&scoped=true&"
import script from "./ExpensesTable.vue?vue&type=script&lang=js&"
export * from "./ExpensesTable.vue?vue&type=script&lang=js&"
import style0 from "./ExpensesTable.vue?vue&type=style&index=0&id=a6bda52c&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a6bda52c",
  null
  
)

export default component.exports